var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccountsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "accounts_icon",
    transform: "translate(-3 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15593",
    "data-name": "Path 15593",
    d: "M60.331,3.6,74.8,18.143l-14.472-.814Z",
    transform: "translate(2.789)",
    fill: "#ffd5d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15594",
    "data-name": "Path 15594",
    d: "M4.831,55.075l1.893-2.451,13.889-1.6-3.631,6.8,9.423,2.466,9.949-2.466-4-6.8h4l10.618,1.6L49.08,56.7V74.942H3.828Z",
    transform: "translate(0 1.548)",
    fill: "#c9f0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    d: "M42,6h5.153V8.533H42Z",
    transform: "translate(11.237 1.067)",
    fill: "#0faceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    d: "M42,10h5.153v2.533H42Z",
    transform: "translate(11.237 2.133)",
    fill: "#0faceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M42,14h5.153v2.533H42Z",
    transform: "translate(11.237 3.2)",
    fill: "#0faceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    d: "M42,18H62.61v2.533H42Z",
    transform: "translate(11.237 4.267)",
    fill: "#0faceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    d: "M40,22H60.186v2.533H40Z",
    transform: "translate(13.662 5.333)",
    fill: "#0faceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    d: "M40,26H60.186v2.533H40Z",
    transform: "translate(13.662 6.4)",
    fill: "#0faceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    d: "M40,30H59.322v2.533H40Z",
    transform: "translate(14.525 7.467)",
    fill: "#0faceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    d: "M52,34H71.322v2.533H52Z",
    transform: "translate(2.525 8.533)",
    fill: "#0faceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    d: "M34,34h7.729v2.533H34Z",
    transform: "translate(8.932 8.533)",
    fill: "#0faceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    d: "M34,38h7.729v2.533H34Z",
    transform: "translate(8.932 9.6)",
    fill: "#0faceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    d: "M52,38H71.322v2.533H52Z",
    transform: "translate(2.525 9.6)",
    fill: "#0faceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    d: "M43,42H62.322v2.533H43Z",
    transform: "translate(11.525 10.667)",
    fill: "#0faceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    d: "M43,46H62.322v2.533H43Z",
    transform: "translate(11.525 11.733)",
    fill: "#0faceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    d: "M43,50H62.322v2.533H43Z",
    transform: "translate(11.525 12.8)",
    fill: "#0faceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    d: "M29.881,31H27.305c0,.315-1.371,1.267-3.864,1.267S19.576,31.315,19.576,31H17c0,2.166,2.768,3.8,6.441,3.8S29.881,33.166,29.881,31Z",
    transform: "translate(4.034 7.733)",
    fill: "#0faceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    d: "M10,52h7.729v2.533H10Z",
    transform: "translate(2.017 13.333)",
    fill: "#0faceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    d: "M78.626,17.631,63.143,2.367a1.311,1.311,0,0,0-.9-.367H27.475a21.749,21.749,0,0,0-21.9,21.533A1.278,1.278,0,0,0,6.864,24.8H6.9a6.186,6.186,0,0,0-.879,6.136,6.357,6.357,0,0,0,4.911,3.883A16.536,16.536,0,0,0,21.034,47.6v2.7L8.526,52.059A6.4,6.4,0,0,0,3,58.329v18.4A1.278,1.278,0,0,0,4.288,78H50.661a1.278,1.278,0,0,0,1.288-1.267v-3.8H75.136A3.844,3.844,0,0,0,79,69.133V18.53a1.243,1.243,0,0,0-.374-.9ZM63.542,6.345l11,10.855H64.83a1.278,1.278,0,0,1-1.288-1.267ZM10.729,32.172a3.823,3.823,0,0,1-2.478-2.735,3.758,3.758,0,0,1,1.022-3.522,4,4,0,0,1,1.456-.887ZM8.191,22.267a19.188,19.188,0,0,1,19.283-17.8,19.188,19.188,0,0,1,19.283,17.8H43.344l-8.682-6.093a1.282,1.282,0,0,0-1.108-.19L11.837,22.267ZM46.8,28.6a3.8,3.8,0,0,1-2.576,3.559V25.028a4.107,4.107,0,0,1,1.443.874A3.784,3.784,0,0,1,46.8,28.6ZM31.339,26.067a1.278,1.278,0,0,0-1.288,1.267V28.6H24.9V27.333a1.278,1.278,0,0,0-1.288-1.267h-7.2l-1.945-1.925L33.67,18.593l7.278,5.1L38.54,26.067ZM37.78,28.6v2.533H32.627V28.6Zm-15.458,0v2.533H17.169V28.6Zm-9.017,3.8V26.586l1.288,1.267V32.4a1.278,1.278,0,0,0,1.288,1.267H23.61A1.278,1.278,0,0,0,24.9,32.4V31.133h5.153V32.4a1.278,1.278,0,0,0,1.288,1.267h7.729A1.278,1.278,0,0,0,40.356,32.4V27.853l1.288-1.267V32.4a14.171,14.171,0,0,1-28.339,0Zm8.862,21.521,2.9,5.713L19.256,58.2Zm4.019,21.546H5.576V58.329a3.846,3.846,0,0,1,3.311-3.762l10.769-1.507L16.1,58.3a1.249,1.249,0,0,0-.125,1.156,1.281,1.281,0,0,0,.885.77l9.326,2.293ZM23.61,51.1V48.411a16.6,16.6,0,0,0,7.729,0V51.1l-3.864,7.6Zm9.172,2.825L35.693,58.2l-5.809,1.431ZM49.373,75.467H28.763V62.521l9.326-2.293a1.281,1.281,0,0,0,.885-.77,1.249,1.249,0,0,0-.125-1.156l-3.555-5.244,10.769,1.507a3.846,3.846,0,0,1,3.311,3.762Zm27.051-6.333A1.278,1.278,0,0,1,75.136,70.4H51.949V58.329a6.4,6.4,0,0,0-5.526-6.27L33.915,50.3V47.6a16.685,16.685,0,0,0,9.017-8.879V40h7.729V37.467H43.4a14.968,14.968,0,0,0,.618-2.647,6.357,6.357,0,0,0,4.911-3.883,6.186,6.186,0,0,0-.879-6.136h.039a1.278,1.278,0,0,0,1.288-1.267,21.5,21.5,0,0,0-11.619-19H60.966v11.4a3.844,3.844,0,0,0,3.864,3.8H76.424Z",
    transform: "translate(0 0)",
    fill: "#0faceb"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountsIcon);
export default __webpack_public_path__ + "static/media/accounts_icon.173a0337d805f65bb3c28dab8a69a44e.svg";
export { ForwardRef as ReactComponent };